import {useCallback} from "react"
import {useQuery, useQueryClient} from "@tanstack/react-query"
import {admissionService} from "services"
import {UNLIMITED_PAGE_SIZE} from "data/constants"
import {AdmissionsConversionStatus, AdmissionsFunnelStatus} from "types/admissions"
import {Order} from "types/common"

const queryCacheKey = "all-conversion-statuses"
const INITIAL_DATA: AdmissionsConversionStatus[] = []

export const useAllConversionStatuses = () => {
    const queryClient = useQueryClient()

    const query = useQuery(
        [queryCacheKey],
        async () => {
            const {data} = await admissionService.getAllConversionStatuses({
                range: {
                    page: 1,
                    pageSize: UNLIMITED_PAGE_SIZE
                },
                sort: {
                    orderBy: "priority",
                    orderDir: Order.Asc
                }
            })
            return data
        },
        {
            refetchOnMount: false
        }
    )
    return {
        conversionStatuses: query.data ?? INITIAL_DATA,
        invalidateConversionStatusesCache: useCallback(() => {
            queryClient.invalidateQueries({queryKey: [queryCacheKey]})
        }, [queryClient])
    }
}
